// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"567cc8059392b51ed7ab","452":"b5348062f21f0a483d04","453":"b1f9b53c60d58add1681","522":"2b50b9b9b36904229dbe","551":"6bd48a9ad68088575585"}[chunkId] + ".js";
};